import { selectBackgroundColor } from '@common/providers/ThemeProvider/selectors';
import Box from '@mui/material/Box';

const CreateFooter = ({ children, position = 'fixed', isLoading = false }) => (
  <Box
    position={position}
    bottom='0'
    left='0'
    right='0'
    padding='0.7rem'
    paddingLeft={0}
    zIndex='10'
    sx={{
      backgroundColor: selectBackgroundColor,
      pointerEvents: isLoading ? 'none' : 'auto',

      width: '100%',
      borderTop: '1px solid lightgrey',
    }}
  >
    <Box
      display='flex'
      flexDirection='row'
      justifyContent='space-between'
      sx={{
        margin: '0 auto',
        px: 2,
      }}
    >
      {children}
    </Box>
  </Box>
);

export default CreateFooter;
